import { Lock } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/cn';

/**
 * A tappable card standing in for an account-based feature while a guest is
 * browsing. Clicking it opens the `AccountGateModal`. Used on Book Detail
 * (save/track, reviews, resources) — the web analog of the iOS guest gate
 * cards. Styled to read as part of the page rather than a hard wall.
 */
export function GuestGateCard({
  icon: Icon,
  title,
  subtitle,
  onActivate,
  className,
}: {
  icon: LucideIcon;
  title: string;
  subtitle: string;
  onActivate: () => void;
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={onActivate}
      className={cn(
        'flex w-full items-center gap-3 rounded-2xl border border-or-slate-200 bg-white p-4 text-left transition hover:border-or-orange-300 hover:bg-or-orange-50/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-or-orange-500/40',
        className,
      )}
    >
      <span
        aria-hidden
        className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-or-orange-50 text-or-orange-600"
      >
        <Icon className="h-5 w-5" />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block font-display text-[15px] font-bold text-or-slate-900">{title}</span>
        <span className="block text-[12px] text-or-slate-500">{subtitle}</span>
      </span>
      <Lock className="h-4 w-4 shrink-0 text-or-slate-400" aria-hidden />
    </button>
  );
}
